import {gsap} from "gsap";

import {ScrollTrigger} from "gsap/ScrollTrigger";
import Swiper from "swiper";



export const ViewHome = {
    namespace: 'home',
    beforeEnter(data) {

    },
    afterLeave() {

        ScrollTrigger.getAll().forEach(trigger => trigger.kill());

        console.log('killl')

    },
    afterEnter() {


        console.log('view home')

        document.querySelector('.header').classList.remove('inverted');


        const swiperProjects = new Swiper('.swiper-projects', {
            slidesPerView: 3,
            allowTouchMove: false,
            spaceBetween: 24,

            breakpoints: {
                // fino a 767px → 1 slide
                0: {
                    slidesPerView: 1.5,
                    allowTouchMove: true, // se vuoi swipe su mobile
                },
                // da 768px in su → 3 slide
                768: {
                    slidesPerView: 3,
                    allowTouchMove: false,
                }
            }

        });


        if (document.querySelectorAll('.block-parallax__item').length > 0) {
            const items = document.querySelectorAll('.block-parallax__item');

            items.forEach((el, i) => {
                // pin tutti tranne l’ultimo
                if (i < items.length - 1) {
                    ScrollTrigger.create({
                        trigger: el,
                        pin: true,
                        pinSpacing: false,
                    });
                }

                // attiva quando entra
                ScrollTrigger.create({
                    trigger: el,
                    start: 'top bottom',
                    onEnter: () => {
                        items.forEach(item => item.classList.remove('active'));
                        el.classList.add('active');
                    },
                });

                // tornando su: attiva il precedente
                ScrollTrigger.create({
                    trigger: el,
                    start: 'top bottom',
                    onLeaveBack: () => {
                        items.forEach(item => item.classList.remove('active'));
                        const prev = items[i - 1] || items[0]; // index precedente
                        prev.classList.add('active');
                    },
                });
            });
        }


    }
}
